import React, { useContext } from 'react'
import { arrayOf, number, string, func, oneOfType } from 'prop-types'
import * as Styled from './SilderMenu.styles'

// helpers
import { TextContext } from 'hocs'

const SliderMenu = ({ slideIds, activeId, handleActiveIdChange }) => {
  const textContext = useContext(TextContext)
  return (
    <Styled.SliderMenu data-cy='compare-slider-menu'>
      <div className='menu-label'>
        {textContext['compare.mobile.menuLabel']}
      </div>
      <div className='menu-wrapper'>
        {slideIds.map((itemId, index) => (
          <div
            key={ index }
            className={ `item ${ activeId === itemId ? 'active' : '' }` }
            onClick={ () => handleActiveIdChange(itemId) }
          />
        ))}
      </div>
    </Styled.SliderMenu>
  )
}

SliderMenu.propTypes = {
  // array of ids from compare collection
  slideIds: arrayOf(oneOfType([number, string])).isRequired,
  // current active element (hospitals string ids, doctors number ids)
  activeId: oneOfType([number, string]).isRequired,
  // handler for changing current active element
  handleActiveIdChange: func.isRequired,
}

export default SliderMenu
